import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, CalendarIcon, PhoneIcon, UserCheckIcon, ClockIcon } from 'lucide-react';
const appointmentSteps = [{
  icon: ClipboardCheckIcon,
  title: 'Submit Request Form',
  description: 'Complete the consultation request form with your information and preferred appointment details.'
}, {
  icon: PhoneIcon,
  title: 'Coordinator Contact',
  description: 'A medical coordinator will contact you to review availability and answer any initial questions.'
}, {
  icon: CalendarIcon,
  title: 'Appointment Scheduled',
  description: 'Your appointment with Dr. Mark Joy, MD is scheduled and confirmed at a mutually convenient time.'
}, {
  icon: UserCheckIcon,
  title: 'Consultation Takes Place',
  description: 'Your scheduled consultation is conducted professionally and confidentially at the appointed time.'
}];
export function WhatToExpect() {
  return <section className="w-full py-20 lg:py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden" data-id="element-412">
      <div className="absolute inset-0" data-id="element-413">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-brand-aqua/10 rounded-full blur-3xl" data-id="element-414" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-primary/10 rounded-full blur-3xl" data-id="element-415" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-416">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 sm:mb-16 px-4" data-id="element-417">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/10 rounded-full mb-4" data-id="element-418">
            <ClockIcon className="w-4 h-4 text-brand-gold" data-id="element-419" />
            <span className="text-brand-gold font-semibold text-xs sm:text-sm uppercase tracking-wider" data-id="element-420">
              Appointment Process
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy mb-4 sm:mb-6" data-id="element-421">
            How the Appointment{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-gold" data-id="element-422">
              Process Works
            </span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-423">
            A clear, coordinated approach to scheduling your medical
            consultation
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-424">
          {appointmentSteps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-brand-gold/10 hover:shadow-xl transition-shadow duration-300" data-id="element-425">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-brand-primary to-brand-gold rounded-2xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg" data-id="element-426">
                <step.icon className="w-6 h-6 sm:w-7 sm:h-7 text-white" strokeWidth={2} data-id="element-427" />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-brand-navy mb-2 sm:mb-3" data-id="element-428">
                {step.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed" data-id="element-429">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}